import { ComponentProps, useCallback, MouseEvent } from 'react';
import { useFormikContext } from 'formik';
import isFunction from 'lodash/isFunction';
import { TableFiltersState } from 'types/common';
import { Button } from '@mui/material';

type Props = ComponentProps<typeof Button>;

export const ResetButton = ({ onClick, ...props }: Props) => {
    const { setTouched, resetForm } = useFormikContext<TableFiltersState>();

    const handleClick = useCallback(
        (e: MouseEvent<HTMLButtonElement>) => {
            if (isFunction(onClick)) {
                onClick(e);
            }
            resetForm();
            setTouched({});
        },
        [resetForm, setTouched, onClick],
    );

    return <Button {...props} type="reset" onClick={handleClick} />;
};
